import { useState, useEffect } from 'react';

interface CurrencyData {
  currencyPair: string;
  type: string;
  buyRate: number;
  sellRate: number;
}

interface UseWebSocketReturn {
  data: CurrencyData[];
  connectionStatus: string;
}

export const useWebSocket = (url: string): UseWebSocketReturn => {
  const [data, setData] = useState<CurrencyData[]>([]);
  const [connectionStatus, setConnectionStatus] = useState<string>("Bağlanıyor...");

  useEffect(() => {
    const ws = new WebSocket(url);
    let reconnectTimeout: NodeJS.Timeout;

    const connectWebSocket = () => {
      ws.onopen = () => {
        setConnectionStatus("Bağlandı");
        console.log("WebSocket bağlantısı kuruldu.");
      };

      ws.onmessage = (event) => {
        try {
          const rawData = JSON.parse(event.data);
          if (Array.isArray(rawData)) {
            const formattedData = rawData.map((item) => ({
              currencyPair: item.Code,
              type: item.Category.toUpperCase().trim(),
              buyRate: item.Bid || 0,
              sellRate: item.Ask || 0,
            }));
            setData(formattedData);
          }
        } catch (error) {
          console.error("WebSocket veri çözümleme hatası:", error);
        }
      };

      ws.onerror = (error) => {
        setConnectionStatus("Bağlantı Hatası");
        console.error("WebSocket hatası:", error);
      };

      ws.onclose = () => {
        setConnectionStatus("Yeniden Bağlanıyor...");
        reconnectTimeout = setTimeout(connectWebSocket, 3000);
      };
    };

    connectWebSocket();

    return () => {
      clearTimeout(reconnectTimeout);
      ws.close();
    };
  }, [url]);

  return { data, connectionStatus };
}; 